import apiRequest from 'store/api/actions';
import { doGet, doPost, doPut } from 'system/httpHelper';
import { endpointFormatter } from 'utils/endpoint';

import {
  CHART_BUILDER_RUN_START,
  CHART_BUILDER_RUN_SUCCESS,
  CHART_BUILDER_RUN_FAIL,
  CHART_BUILDER_CLEAR,
  FETCH_DASHBOARD_SETTINGS_START,
  FETCH_DASHBOARD_SETTINGS_SUCCESS,
  FETCH_DASHBOARD_SETTINGS_FAIL,
  SAVE_DASHBOARD_SETTINGS_START,
  SAVE_DASHBOARD_SETTINGS_SUCCESS,
  SAVE_DASHBOARD_SETTINGS_FAIL,
} from './types';

/* -------------------------------------------------------------------------- */
/*                               Chart Builder                                */
/* -------------------------------------------------------------------------- */

export const runStart = (selection) => ({
  type: CHART_BUILDER_RUN_START,
  payload: { selection },
});

export const runSuccess = (result) => ({
  type: CHART_BUILDER_RUN_SUCCESS,
  payload: result,
});

export const runFail = (error) => ({
  type: CHART_BUILDER_RUN_FAIL,
  payload: error,
});

export const clear = () => ({
  type: CHART_BUILDER_CLEAR,
});

/* -------------------------------------------------------------------------- */
/*                        Fetch Dashboard Settings                             */
/* -------------------------------------------------------------------------- */

export const fetchDashboardSettingsStart = () => ({
  type: FETCH_DASHBOARD_SETTINGS_START,
});

export const fetchDashboardSettingsSuccess = (payload) => ({
  type: FETCH_DASHBOARD_SETTINGS_SUCCESS,
  payload,
});

export const fetchDashboardSettingsFail = (error) => ({
  type: FETCH_DASHBOARD_SETTINGS_FAIL,
  payload: error,
});

export const fetchDashboardSettings =
  ({ siteId, userEmail }) =>
  (dispatch) => {
    dispatch(fetchDashboardSettingsStart());

    const apiUrl = endpointFormatter('fetchUserDashboardSettings', {
      siteId,
      userEmail,
    });

    dispatch(
      apiRequest(
        () => doGet(apiUrl),
        fetchDashboardSettingsSuccess,
        fetchDashboardSettingsFail,
        false,
      ),
    );
  };

/* -------------------------------------------------------------------------- */
/*                        Save Dashboard Settings                              */
/* -------------------------------------------------------------------------- */

export const saveDashboardSettingsStart = () => ({
  type: SAVE_DASHBOARD_SETTINGS_START,
});

export const saveDashboardSettingsSuccess = (payload) => ({
  type: SAVE_DASHBOARD_SETTINGS_SUCCESS,
  payload,
});

export const saveDashboardSettingsFail = (error) => ({
  type: SAVE_DASHBOARD_SETTINGS_FAIL,
  payload: error,
});

export const saveDashboardSettings =
  ({ siteId, userEmail, payload }) =>
  (dispatch, getState) => {
    dispatch(saveDashboardSettingsStart());

    const apiUrl = endpointFormatter('upsertUserDashboardSettings', {
      siteId,
      userEmail,
    });

    const existingSettings = getState?.().chartBuilder?.settings;
    const settingsForCurrentSite =
      existingSettings && Number(existingSettings?.siteId) === Number(siteId)
        ? existingSettings
        : null;
    const hasExisting =
      !!settingsForCurrentSite &&
      (settingsForCurrentSite.id ||
        settingsForCurrentSite.userPreferredChartsId ||
        (settingsForCurrentSite.chartPreferences &&
          Object.keys(settingsForCurrentSite.chartPreferences).length > 0));

    dispatch(
      apiRequest(
        () => (hasExisting ? doPut(apiUrl, payload) : doPost(apiUrl, payload)),
        saveDashboardSettingsSuccess,
        saveDashboardSettingsFail,
      ),
    );
  };
